import React from 'react';
import { Breadcrumb } from 'antd';
import classNames from 'classnames';
import 'antd/lib/breadcrumb/style/index.less';
import Link from 'next/link';
import styles from './index.module.scss';

interface BreadcrumbBaseProps {
  list: { href?: string; title: string }[];
  className?: string;
}

export default function BreadcrumbBase({ list = [], className }: BreadcrumbBaseProps) {
  const BreadcrumbItems = list.map((item, index) => {
    return (
      <>
        {item.href ? (
          <Breadcrumb.Item key={index}>
            <Link href={{ pathname: item.href }}>
              <a>{item.title}</a>
            </Link>
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item key={index}>
            <span>{item.title}</span>
          </Breadcrumb.Item>
        )}
      </>
    );
  });
  return <Breadcrumb className={classNames(styles.breadcrumb, className)}>{BreadcrumbItems}</Breadcrumb>;
}
